import { useGeoLookupContext } from '@/hooks/useGeoLookupContext';
import { config } from '@/pageConfig/car/us/en';
import { CarPageTemplate } from '@/pageTemplate/CarPageTemplate';
import { useEffect } from 'react';

export default function CarPage() {
  const { trackEventWithGeolocation } = useGeoLookupContext();
  // biome-ignore lint/correctness/useExhaustiveDependencies: want to track event only once
  useEffect(
    () =>
      trackEventWithGeolocation('car_page.viewed', {
        variant: 'default',
        priceType: 'fixed',
        experiment: 'bottom_sticky_cta_off',
      }),
    [],
  );

  return <CarPageTemplate config={config} isNjEnabled={false} />;
}
